import { FC, PropsWithChildren, RefObject } from 'react';
import SelectOverlay from '__components/Inputs/SelectOverlay';
import { StyledOverlayWrapper } from '../styles';
import { preventOverflow } from '__components/Inputs/inline/helpers';
import { popperModifiers } from '__components/helpers';
import { layers } from '__app/spacing';

const modalPopperConfig = {
  modifiers: [
    preventOverflow,
    popperModifiers.addStyles({ zIndex: layers.popoverInModal - 5 }), // Enough to be above the parent modal and below configure link modal
  ],
};

const detailsPopperConfig = {
  modifiers: [preventOverflow, popperModifiers.addStyles({ zIndex: 3 })],
};

export const MarkdownOverlay: FC<
  PropsWithChildren<{
    show: boolean;
    onHide: () => void;
    targetRef: RefObject<HTMLDivElement>;
    containerRef?: RefObject<HTMLDivElement>;
    inModal?: boolean;
    initialWidth?: number;
  }>
> = ({
  children,
  show,
  onHide,
  targetRef,
  containerRef,
  inModal = false,
  initialWidth,
}) => {
  const handleHide = (e: PointerEvent) => {
    const node = e.target as Node;
    const element = e.target as HTMLElement;

    if (
      !containerRef?.current?.contains(node) &&
      !element.closest?.('.wysiwyg-modal')
    ) {
      onHide();
    }
  };

  return (
    <SelectOverlay
      show={show}
      onHide={handleHide}
      target={targetRef.current}
      iDoNotWantToMountTwice
      popperConfig={inModal ? modalPopperConfig : detailsPopperConfig}
      // prevents closing popover on selecting text, resizing etc when cursor gets outside the popover
      rootCloseEvent="mousedown"
    >
      <StyledOverlayWrapper
        data-qa="markdown-overlay"
        initialWidth={initialWidth}
      >
        {children}
      </StyledOverlayWrapper>
    </SelectOverlay>
  );
};
